import React, { useEffect, useRef, useState } from "react";

const FALLBACK = "/hero/layers-original.png";

export default function LayersHero({ fixed = false, className = "" }) {
  const ref = useRef(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    let handle = null;
    let io = null;
    let cancelled = false;
    import("@/lib/hero/scene").then(({ mountLayersScene }) => {
      if (cancelled) return;
      try {
        handle = mountLayersScene(el, { listen: fixed ? document.documentElement : el, light: fixed });
      } catch (err) {
        console.error("Anteprima 3D non disponibile", err);
        setFailed(true);
        return;
      }
      io = new IntersectionObserver(([entry]) => handle?.setVisible(entry.isIntersecting), { threshold: 0.05 });
      io.observe(el);
    }).catch(() => setFailed(true));
    return () => { cancelled = true; io?.disconnect(); handle?.dispose(); };
  }, [fixed]);

  const box = fixed ? "fixed inset-0 z-0 pointer-events-none" : "relative w-full h-[300px] md:h-[450px] rounded-2xl touch-none";
  return (
    <div
      ref={ref}
      data-testid="layers-hero"
      aria-hidden="true"
      className={`overflow-hidden bg-[#171e25] ${box} ${className}`}
      style={failed ? { backgroundImage: `url(${FALLBACK})`, backgroundSize: "cover", backgroundPosition: "center" } : undefined}
    />
  );
}
